import { useUploadImageMutation } from '@modules/Dashboard/Product/components/OfferImages/hooks/useUpload/useUploadImageMutation';
import { useMutation } from '@tanstack/react-query';
import { mapUploadedFilesToVariantImages } from './mapUploadedFilesToVariantImages/mapUploadedFilesToProductVariantImages';
export const useUploadImages = ({ filters }) => {
    const { uploadImageMutation } = useUploadImageMutation();
    const mapFileToUploadPromise = (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return uploadImageMutation.mutateAsync([formData]);
    };
    const uploadBlobs = async (images) => {
        const promises = images.map(async (image) => {
            const result = await mapFileToUploadPromise(image.blob);
            return {
                result,
                uploadToAllVariants: image.uploadToAllVariants,
            };
        });
        const results = await Promise.all(promises);
        const mappedImages = mapUploadedFilesToVariantImages({ results, filters });
        return mappedImages;
    };
    return { uploadBlobs: useMutation(uploadBlobs) };
};
